<template>
    <div
        class="goods-console"
        :class="{ 'is-disabled': disabled }"
        v-loading="loading"
        element-loading-text="正在加载商品列表..."
    >
        <miaopinDrawer v-if="!disabled" :visible.sync="showMiaopinDrawer" :product-id="MiaopinProductID" @select-sku="handleImportSku"
            :get-live-source-el="getLiveSourceEl">
        </miaopinDrawer>
        <SkuSelectorDrawer v-if="!disabled" :visible.sync="showGoodsDrawer" :existing-product-ids="existingShopProductIds" :importing="importingGoods" @select-sku="handleImportSku">
        </SkuSelectorDrawer>
        <div v-if="disabled" class="readonly-tip">
            {{ disabledMessage }}
        </div>

        <!-- 顶部操作栏 -->
        <div class="console-header">
            <div class="console-left">
                <label class="check-all">
                    <input type="checkbox" :checked="isAllChecked" :disabled="disabled" @change="toggleAll" />
                    <span>全选</span>
                </label>

                <button
                    class="btn-batch-remove"
                    :disabled="disabled || removing || !selectedIds.length"
                    @click="requestBatchRemove"
                >
                    <i class="el-icon-delete"></i>
                    {{ batchRemoveLabel }}
                </button>

                <div class="search-box">
                    <input v-model="keyword" type="text" placeholder="请输入商品名称或ID" :disabled="disabled" @keyup.enter="emitSearch" />
                    <button class="btn-search" :disabled="disabled" @click="emitSearch">🔍</button>
                </div>

                <!-- <div class="filter-box">
                    <button class="btn-filter" @click="$emit('open-filter')">
                        筛选 ▾
                    </button>
                </div> -->
            </div>

            <div class="console-right">
                <button class="btn-refresh" :disabled="disabled" @click="emitRefresh">
                    <i class="el-icon-refresh"></i>
                    刷新列表
                </button>
                <button class="btn-add" :disabled="disabled" @click="openGoodsDrawer">
                    + 添加商品
                </button>
            </div>
        </div>

        <!-- 表头 -->
        <div class="goods-header-row">
            <div class="col col-index"></div>
            <div class="col col-main">商品信息</div>
            <div class="col col-price">到手价</div>
            <div class="col col-stock">售出/库存</div>
            <!-- <div class="col col-amount">成交金额</div>
            <div class="col col-rate">曝光成交率</div> -->
            <div class="col col-actions">操作</div>
        </div>

        <!-- 商品列表 -->
        <div class="goods-list">
            <div v-for="(item, index) in innerList" :key="item.id">
                <div class="goods-row" :class="{
                    'goods-row--dragging': index === dragIndex,
                    'goods-row--dragover': index === dragOverIndex
                }" :draggable="!disabled && editingOrderId !== item.id" @dragstart="onDragStart(index, $event)"
                    @dragover.prevent="onDragOver(index, $event)" @drop.prevent="onDrop(index, $event)"
                    @dragend="onDragEnd">
                    <!-- 左侧序号 + 选择框 -->
                    <div class="col col-index">
                        <div class="index-inner">
                            <span class="drag-handle">⋮⋮</span>
                            <input
                                v-if="editingOrderId === item.id"
                                ref="orderInputs"
                                v-model="editingOrderValue"
                                class="index-order-input"
                                type="number"
                                :min="1"
                                :max="innerList.length"
                                :disabled="disabled"
                                @click.stop
                                @mousedown.stop
                                @keyup.enter.stop="commitOrderEdit(item, index)"
                                @keyup.esc.stop="cancelOrderEdit"
                                @blur="commitOrderEdit(item, index)"
                            />
                            <button
                                v-else
                                class="index-num index-num--editable"
                                type="button"
                                :disabled="disabled"
                                title="点击输入新的排序位置"
                                :aria-label="`修改第 ${index + 1} 个商品的排序位置`"
                                @mousedown.stop
                                @click.stop="startOrderEdit(item, index)"
                            >
                                {{ index + 1 }}
                            </button>
                            <input type="checkbox" :checked="selectedIds.indexOf(item.id) !== -1"
                                :disabled="disabled" @change="toggleOne(item.id)" />
                            <button
                                v-if="index > 0"
                                class="btn-pin-top"
                                type="button"
                                :disabled="disabled"
                                @mousedown.stop
                                @click.stop="pinToTop(item, index)"
                            >置顶</button>
                        </div>
                    </div>

                    <!-- 商品信息 -->
                    <div class="col col-main">
                        <div class="main-inner">
                            <img class="thumb" :src="item.images[0].url || ''" alt="" />
                            <div class="main-text">
                                <div class="title" :title="item.title">
                                    {{ item.title }}
                                </div>
                                <div class="tags">
                                    <span v-for="(tag, i) in item.tags || []" :key="i" class="tag">
                                        {{ tag }}
                                    </span>
                                </div>
                                <div class="status-line">
                                    <span class="status" v-if="item.statusText">
                                        {{ item.statusText }}
                                    </span>
                                    <button v-if="item.canSetHotspot" class="link-btn" :disabled="disabled"
                                        @click.stop="$emit('set-hot', item)">
                                        设置卖点 ✎
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 到手价 -->
                    <div class="col col-price">
                        ${{ item.price | fmtMoney }}
                    </div>

                    <!-- 售出/库存 -->
                    <div class="col col-stock">
                        {{ item.sold || 0 }}/{{ item.stock || 0 }}
                    </div>


                    <!-- 操作按钮 -->
                    <div class="col col-actions">
                        <!-- <button class="btn-ghost" @click="$emit('show-data', item)">
                        更多数据
                    </button> -->
                        <button class="btn-ghost" :disabled="disabled" @click="$emit('toggle-offline', item)">
                            移除购物车
                        </button>
                        <button v-if="!item.sku.length" class="btn-ghost" :disabled="disabled" @click="$emit('explain', item)">
                            讲解
                        </button>
                        <button class="btn-ghost" :disabled="disabled" @click="addMiaopin(item)">
                            秒拼
                        </button>
                        <!-- <button class="btn-more" @click="$emit('more', item)">⋯</button> -->
                    </div>
                </div>
                <div v-if="item.sku.length" style="margin-left: 50px;">
                    <div v-for="(sku, sku_index) in item.sku" class="goods-row">
                        <div class="col col-index" style="width: 70px;">
                            <div class="index-inner">
                                <span class="index-num">{{ sku_index + 1 }}</span>
                            </div>
                        </div>
                        <!-- SKU信息 -->
                        <div class="col col-main">
                            <div class="main-inner">
                                <img class="thumb" :src="sku.image || sku.image.url" alt="" />
                                <div class="main-text">
                                    <div class="title" :title="sku.sedkill_product_sku_title">
                                        {{ sku.sedkill_product_sku_title }}
                                    </div>
                                    <div class="tags">
                                        <span v-for="(tag, i) in item.tags || []" :key="i" class="tag">
                                            {{ tag }}
                                        </span>
                                    </div>
                                    <div class="status-line">
                                        <span class="status" v-if="sku.sell_status">
                                            {{ sku.sell_status ? '上架中' : '下架中' }}
                                        </span>
                                        <!-- <button v-if="item.canSetHotspot" class="link-btn"
                                            @click.stop="$emit('set-hot', item)">
                                            设置卖点 ✎
                                        </button> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 到手价 -->
                        <div class="col col-price">
                            ${{ sku.sedkill_price | fmtMoney }}
                        </div>

                        <!-- 售出/库存 -->
                        <div class="col col-stock">
                            {{ sku.stock || 0 }}
                        </div>


                        <!-- 操作按钮 -->
                        <div class="col col-actions">
                            <!-- <button class="btn-ghost" @click="$emit('show-data', item)">
                        更多数据
                    </button> -->
                            <button class="btn-ghost" :disabled="disabled" @click="$emit('explain', sku)">
                                讲解
                            </button>
                            <button class="btn-ghost" :disabled="disabled" @click="saleSwicth(sku.id)">
                                {{ sku.sell_status ? '下架' : '上架' }}
                            </button>
                            <button
                                v-copy="`https://shop.wokfoy.com/pages/product/product-detail?id=${item.id}&stream_id=${$store.state.currentRoom}&sku_id=${sku.id}`"
                                class="btn-ghost">
                                复制链接
                            </button>
                            <!-- <button class="btn-more" @click="$emit('more', item)">⋯</button> -->
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!innerList.length" class="empty">
                暂无商品，请点击右上角「添加商品」
            </div>
        </div>
    </div>
</template>

<script>
import SkuSelectorDrawer from './SkuSelectorDrawer.vue';
import miaopinDrawer from './miaopinedit.vue';
import {
    SaveProduct,
    miaopin_create,
    miaopin_swicth_sale_status
} from '@/api/index';
export default {
    name: 'LiveGoodsManager',
    props: {
        disabledMessage: { type: String, default: "历史直播商品列表只读，编辑操作已禁用" },
        // 商品列表
        items: {
            type: Array,
            default: function () {
                return []
            }
        },
        getLiveSourceEl: { type: Function, required: false },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        removing: {
            type: Boolean,
            default: false
        },
        removalProgress: {
            type: Object,
            default: function () {
                return { current: 0, total: 0 }
            }
        },
        selectionKey: {
            type: [String, Number],
            default: ''
        }
    },
    components: {
        miaopinDrawer,
        SkuSelectorDrawer
    },
    data() {
        return {
            innerList: [],       // 本地可拖拽列表
            dragIndex: null,
            dragOverIndex: null,
            selectedIds: [],
            keyword: '',
            showGoodsDrawer: false,
            showMiaopinDrawer: false,
            MiaopinProductID: null,
            editingOrderId: null,
            editingOrderValue: '',
            importingGoods: false
        }
    },
    computed: {
        isAllChecked() {
            return (
                this.innerList.length > 0 &&
                this.selectedIds.length === this.innerList.length
            )
        },
        batchRemoveLabel() {
            if (this.removing) {
                var current = Number(this.removalProgress.current) || 0
                var total = Number(this.removalProgress.total) || this.selectedIds.length
                return `正在移除 ${current}/${total}`
            }
            return `批量移除${this.selectedIds.length ? `（${this.selectedIds.length}）` : ''}`
        },
        existingShopProductIds() {
            return this.innerList
                .map((item) => item && item.shop_product_id)
                .filter((id) => id !== undefined && id !== null && id !== '')
        }
    },
    watch: {
        items: {
            immediate: true,
            handler: function (val) {
                this.innerList = (val || []).slice()
                var availableIds = this.innerList.map(function (item) { return item.id })
                var nextSelectedIds = this.selectedIds.filter(function (id) {
                    return availableIds.indexOf(id) !== -1
                })
                if (nextSelectedIds.length !== this.selectedIds.length) {
                    this.selectedIds = nextSelectedIds
                    this.$emit('select-change', this.selectedIds.slice())
                }
                if (this.editingOrderId != null && availableIds.indexOf(this.editingOrderId) === -1) {
                    this.cancelOrderEdit()
                }
            }
        },
        selectionKey: function () {
            this.setSelectedIds([])
        }
    },
    filters: {
        fmtMoney: function (v) {
            if (v == null || v === '') return '0.00'
            var num = Number(v) || 0
            return num.toFixed(2)
        }
    },
    methods: {
        guardReadonly() {
            if (!this.disabled) return false
            if (this.$message) this.$message.warning('历史直播商品列表只读')
            return true
        },
        emitRefresh() {
            if (this.guardReadonly()) return
            this.$emit('refresh')
        },
        openGoodsDrawer() {
            if (this.guardReadonly()) return
            this.showGoodsDrawer = true
        },
        /* ====== 选择相关 ====== */
        toggleAll() {
            if (this.guardReadonly()) return
            if (this.isAllChecked) {
                this.selectedIds = []
            } else {
                this.selectedIds = this.innerList.map(function (it) { return it.id })
            }
            this.$emit('select-change', this.selectedIds.slice())
        },
        toggleOne(id) {
            if (this.guardReadonly()) return
            var arr = this.selectedIds.slice()
            var idx = arr.indexOf(id)
            if (idx === -1) arr.push(id)
            else arr.splice(idx, 1)
            this.selectedIds = arr
            this.$emit('select-change', this.selectedIds.slice())
        },
        setSelectedIds(ids) {
            var availableIds = this.innerList.map(function (item) { return item.id })
            this.selectedIds = (ids || []).filter(function (id, index, list) {
                return list.indexOf(id) === index && availableIds.indexOf(id) !== -1
            })
            this.$emit('select-change', this.selectedIds.slice())
        },
        requestBatchRemove() {
            if (this.guardReadonly() || this.removing || !this.selectedIds.length) return
            var selectedItems = this.innerList.filter((item) => this.selectedIds.indexOf(item.id) !== -1)
            this.$emit('batch-remove', {
                ids: this.selectedIds.slice(),
                items: selectedItems,
            })
        },

        /* ====== 搜索 ====== */
        emitSearch() {
            if (this.guardReadonly()) return
            this.$emit('search', this.keyword.trim())
        },

        /* ====== 拖拽排序 ====== */
        onDragStart(index, evt) {
            if (this.disabled || this.editingOrderId != null) return
            this.dragIndex = index
            this.dragOverIndex = index
            try {
                // 为了兼容某些浏览器，需要设置 drag data
                evt.dataTransfer.effectAllowed = 'move'
                evt.dataTransfer.setData('text/plain', String(index))
            } catch (e) { }
        },
        onDragOver(index, evt) {
            if (this.disabled) return
            if (this.dragIndex == null) return
            this.dragOverIndex = index
        },
        onDrop(index, evt) {
            if (this.guardReadonly()) return
            if (this.dragIndex == null || this.dragIndex === index) return
            var list = this.innerList.slice()
            var moved = list.splice(this.dragIndex, 1)[0]
            list.splice(index, 0, moved)
            this.innerList = list
            this.dragIndex = index
            this.dragOverIndex = null
            // 通知父组件顺序变更
            this.$emit('reorder', this.innerList.slice())
        },
        onDragEnd() {
            this.dragIndex = null
            this.dragOverIndex = null
        },
        startOrderEdit(item, index) {
            if (this.guardReadonly()) return
            this.editingOrderId = item.id
            this.editingOrderValue = String(index + 1)
            this.$nextTick(() => {
                var inputs = this.$refs.orderInputs
                var input = Array.isArray(inputs) ? inputs[0] : inputs
                if (input) {
                    input.focus()
                    input.select()
                }
            })
        },
        cancelOrderEdit() {
            this.editingOrderId = null
            this.editingOrderValue = ''
        },
        commitOrderEdit(item, currentIndex) {
            if (this.editingOrderId !== item.id) return
            var requestedPosition = Number(this.editingOrderValue)
            this.cancelOrderEdit()
            if (!Number.isFinite(requestedPosition)) return
            var targetIndex = Math.max(0, Math.min(this.innerList.length - 1, Math.round(requestedPosition) - 1))
            if (targetIndex === currentIndex) return
            this.moveItemTo(item.id, targetIndex)
        },
        pinToTop(item, index) {
            if (this.guardReadonly() || index === 0) return
            this.cancelOrderEdit()
            this.moveItemTo(item.id, 0)
        },
        moveItemTo(itemId, targetIndex) {
            var list = this.innerList.slice()
            var currentIndex = list.findIndex(function (item) { return item.id === itemId })
            if (currentIndex === -1 || currentIndex === targetIndex) return
            var moved = list.splice(currentIndex, 1)[0]
            list.splice(targetIndex, 0, moved)
            this.innerList = list
            this.$emit('reorder', list.slice())
        },
        normalizeProductKey(value) {
            if (value === undefined || value === null || value === '') return ''
            return String(value)
        },
        sourceProductKey(product) {
            if (!product || typeof product !== 'object') return ''
            return this.normalizeProductKey(product.shop_product_id || product.product_id || product.id)
        },
        async handleImportSku({ product, products, isExport = false }) {
            if (this.guardReadonly()) return
            if (this.importingGoods) {
                if (this.$message) this.$message.warning('商品正在导入，请稍候')
                return
            }
            // console.log('导入到直播间：', product)
            // let payload = {
            //     stream_id: this.$store.state.currentRoom,
            //     ...product
            // }
            // let { code } = isExport ? await SaveProduct(payload) : await miaopin_create(payload)
            // if (code == 0) {
            //     this.showMiaopinDrawer = false
            //     this.showGoodsDrawer = false
            //     this.$emit('refresh')
            // }
            const list = (products && products.length) ? products : (product ? [product] : [])
            if (!list.length) return

            var duplicateCount = 0
            var candidates = list
            if (isExport) {
                var existingKeys = new Set(this.existingShopProductIds.map(this.normalizeProductKey))
                candidates = list.filter((item) => {
                    var key = this.sourceProductKey(item)
                    if (key && existingKeys.has(key)) {
                        duplicateCount++
                        return false
                    }
                    if (key) existingKeys.add(key)
                    return true
                })
            }
            if (!candidates.length) {
                if (this.$message) this.$message.warning('所选商品已在直播购物车中，无需重复导入')
                return
            }

            const stream_id = this.$store.state.currentRoom
            let ok = 0, fail = 0

            this.importingGoods = true
            try {
                for (const p of candidates) {
                    try {
                        const payload = { stream_id, ...p }
                        const res = isExport ? await SaveProduct(payload) : await miaopin_create(payload)
                        if (res && res.code == 0) ok++
                        else fail++
                    } catch (e) {
                        fail++
                        console.error('导入失败：', e)
                    }
                }

                if (ok > 0) {
                    this.importingGoods = false
                    this.showMiaopinDrawer = false
                    this.showGoodsDrawer = false
                    this.$emit('refresh')
                }

                if (this.$message) {
                    if (fail === 0 && duplicateCount === 0) this.$message.success(`导入成功：${ok} 个`)
                    else this.$message.warning(`导入完成：成功 ${ok} 个，重复跳过 ${duplicateCount} 个，失败 ${fail} 个`)
                }
            } finally {
                this.importingGoods = false
            }
        },
        addMiaopin(product) {
            if (this.guardReadonly()) return
            this.MiaopinProductID = product.id
            this.showMiaopinDrawer = true
        },
        async saleSwicth(skuid) {
            if (this.guardReadonly()) return
            await miaopin_swicth_sale_status(skuid)
            this.$emit('refresh')
        }
    }
}
</script>

<style scoped>
.goods-console {
    background: #f5f6f8;
    padding: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', sans-serif;
    font-size: 13px;
    color: #333;
}

.readonly-tip {
    margin-bottom: 12px;
    padding: 8px 12px;
    border: 1px solid #f1d8a8;
    border-radius: 4px;
    background: #fff8e8;
    color: #9a6a00;
}

.goods-console.is-disabled button:disabled,
.goods-console.is-disabled input:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.goods-console.is-disabled .drag-handle {
    cursor: not-allowed;
}

/* 顶部操作栏 */
.console-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 12px;
}

.console-left {
    display: flex;
    align-items: center;
    flex: 1 1 360px;
    flex-wrap: wrap;
    gap: 12px;
}

.check-all {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
}

.search-box {
    display: flex;
    align-items: center;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #ddd;
    overflow: hidden;
}

.search-box input {
    border: none;
    outline: none;
    padding: 4px 8px;
    width: 220px;
    font-size: 13px;
}

.btn-search {
    border: none;
    width: 32px;
    height: 28px;
    background: #fff;
    cursor: pointer;
}

.filter-box .btn-filter {
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 4px;
    padding: 4px 10px;
    cursor: pointer;
    font-size: 13px;
}

.console-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 8px;
}

.btn-refresh {
    border: none;
    background: #26d58f;
    border-radius: 4px;
    padding: 6px 14px;
    color: #fff;
    cursor: pointer;
    font-size: 13px;
}

.btn-batch-remove {
    border: 1px solid #f1a8a8;
    background: #fff;
    border-radius: 4px;
    padding: 5px 12px;
    color: #d93026;
    cursor: pointer;
    font-size: 13px;
    white-space: nowrap;
}

.btn-batch-remove:hover:not(:disabled) {
    border-color: #d93026;
    background: #fff1f0;
}

.btn-batch-remove:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.btn-add {
    border: none;
    background: #1677ff;
    color: #fff;
    border-radius: 4px;
    padding: 6px 14px;
    cursor: pointer;
    font-size: 13px;
}

/* 表头 */
.goods-header-row {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: #f8f8f8;
    border-radius: 8px 8px 0 0;
    color: #999;
}

.goods-list {
    background: #fff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* 行布局 */
.goods-row {
    display: flex;
    align-items: stretch;
    padding: 10px 12px;
    border-top: 1px solid #f2f2f2;
    background: #fff;
}

.goods-row:first-child {
    border-top: none;
}

.goods-row--dragging {
    opacity: 0.6;
}

.goods-row--dragover {
    box-shadow: inset 0 0 0 1px #1677ff;
}

.col {
    display: flex;
    align-items: center;
}

.col-index {
    width: 120px;
}

.index-inner {
    display: flex;
    align-items: center;
    gap: 6px;
}

.drag-handle {
    cursor: move;
    color: #ccc;
    font-size: 16px;
}

.index-num {
    width: 20px;
    text-align: center;
    color: #666;
}

.index-num--editable {
    height: 24px;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: transparent;
    cursor: text;
    font: inherit;
}

.index-num--editable:hover,
.index-num--editable:focus-visible {
    color: #1677ff;
    background: #eef5ff;
    outline: none;
}

.index-order-input {
    width: 42px;
    height: 26px;
    padding: 0 3px;
    border: 1px solid #1677ff;
    border-radius: 4px;
    color: #333;
    text-align: center;
    outline: none;
    box-sizing: border-box;
}

.btn-pin-top {
    padding: 0;
    border: 0;
    background: transparent;
    color: #1677ff;
    cursor: pointer;
    font-size: 12px;
    line-height: 24px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
}

.goods-row:hover .btn-pin-top,
.btn-pin-top:focus-visible {
    opacity: 1;
    visibility: visible;
}

.btn-pin-top:hover {
    color: #0958d9;
    text-decoration: underline;
}

.col-main {
    flex: 1;
}

.col-price,
.col-stock,
.col-amount,
.col-rate {
    width: 120px;
    justify-content: center;
    color: #555;
}

.col-actions {
    width: 210px;
    justify-content: flex-end;
    gap: 6px;
}

/* 商品信息 */
.main-inner {
    display: flex;
    align-items: center;
}

.thumb {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    object-fit: cover;
    margin-right: 10px;
}

.main-text {
    display: flex;
    flex-direction: column;
}

.title {
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 4px;
    max-width: 320px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 4px;
}

.tag {
    padding: 2px 6px;
    border-radius: 2px;
    background: #f2f5ff;
    color: #5670ff;
    font-size: 11px;
}

.status-line {
    display: flex;
    align-items: center;
    gap: 8px;
}

.status {
    font-size: 12px;
    color: #999;
}

.link-btn {
    border: none;
    background: transparent;
    color: #1677ff;
    cursor: pointer;
    font-size: 12px;
    padding: 0;
}

/* 操作按钮 */
.btn-ghost {
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    cursor: pointer;
}

.btn-more {
    border: none;
    background: #fff;
    font-size: 18px;
    cursor: pointer;
}

/* 空态 */
.empty {
    padding: 40px 0;
    text-align: center;
    color: #999;
}
</style>
